import { render, staticRenderFns } from "./PendingPackage.vue?vue&type=template&id=08e5a0a1"
import script from "./PendingPackage.vue?vue&type=script&lang=js"
export * from "./PendingPackage.vue?vue&type=script&lang=js"
import style0 from "./PendingPackage.vue?vue&type=style&index=0&id=08e5a0a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports